import { skillsTypes } from '../actions/_skills_actions';

const skillsReducerDefaultState = {};

export default (state = skillsReducerDefaultState, action) => {
  switch (action.type) {
    case skillsTypes.GET_PLATFORM_DATA:
      return {
        skills: action.data,
      };
    default:
      return state;
  }
};
